import { render } from "./CardBudgetKpi.vue?vue&type=template&id=c3b15812&scoped=true"
import script from "./CardBudgetKpi.vue?vue&type=script&lang=js"
export * from "./CardBudgetKpi.vue?vue&type=script&lang=js"

import "./CardBudgetKpi.vue?vue&type=style&index=0&id=c3b15812&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3b15812"]])

export default __exports__